import * as React from 'react';

import { cn } from '../utils';

export interface DataGridProps {
  /** Total height of all rows combined */
  totalRowHeight: number;
  /** Total width of all columns combined */
  totalColumnWidth: number;
  /** Height of the header row */
  headerHeight: number;
  /** Additional CSS classes */
  className?: string;
  /** Additional styles */
  style?: React.CSSProperties;
  /** Children components (header, sticky column, main grid) */
  children: React.ReactNode;
}

/**
 * Root container for a virtualized data grid with sticky headers and columns.
 * Provides the scrollable container and positioning context for all child components.
 */
export const DataGrid = React.forwardRef<HTMLDivElement, DataGridProps>(
  (
    {
      totalRowHeight,
      totalColumnWidth,
      headerHeight,
      className,
      style,
      children,
    },
    ref,
  ) => {
    return (
      <div
        role="table"
        ref={ref}
        className={cn('overflow-auto w-full', className)}
        style={{
          ...style,
        }}
      >
        <div
          style={{
            position: 'relative',
            height: totalRowHeight + headerHeight,
            minWidth: totalColumnWidth,
          }}
        >
          {children}
        </div>
      </div>
    );
  },
);

DataGrid.displayName = 'DataGrid';
